//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { envConfig } from '@/js/constants';
import tasks from '@/js/tasks';
var pagitation = new tasks.PaginationHelp();
export default {
  name: 'Pagination',
  props: {
    queryObject: {
      type: Object,
      default: null
    },
    reloadMethod: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      historyPageToken: {
        index: 0,
        list: [null]
      },
      showPrev: true,
      showNext: true,
      PAGE_SIZE: envConfig.pagintaionSize,
      queryResponse: {}
    };
  },
  watch: {
    'queryObject': function queryObject(val) {
      this.queryResponse = val;
    }
  },
  created: function created() {
    pagitation.set(this);
    this.queryResponse = this.queryObject;
  },
  methods: {
    goFirst: function goFirst() {
      pagitation.first(this);
    },
    goPrev: function goPrev() {
      pagitation.back(this);
    },
    goNext: function goNext() {
      pagitation.next(this);
    }
  }
};